import React from 'react'

export default function IphoneIcon() {
   return (
      <svg
         width="64"
         height="74"
         viewBox="0 0 64 74"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <g clipPath="url(#clip0_2355_46612)">
            <path
               d="M31.4983 17.9038C35.5852 17.9038 39.1705 16.3079 42.254 13.116C45.3375 9.9241 46.8794 6.21249 46.8794 1.98117C46.8794 1.51645 46.8426 0.856063 46.7693 0C46.2308 0.0733768 45.827 0.134524 45.5578 0.183442C41.7891 0.721539 38.473 2.56819 35.6097 5.72332C32.7464 8.87852 31.3148 12.2539 31.3148 15.8493C31.3148 16.265 31.3759 16.95 31.4983 17.9038ZM46.1452 74C49.0574 74 52.2756 72.0067 55.7997 68.0199C59.3238 64.0331 62.0157 59.3492 63.8756 53.9683C56.9499 50.3973 53.487 45.2732 53.487 38.5959C53.487 33.0193 56.2891 28.2499 61.8934 24.2876C58.0022 19.4202 52.863 16.9866 46.4756 16.9866C43.7835 16.9866 41.3241 17.3902 39.0971 18.1973L37.7022 18.7109L35.83 19.4447C34.6063 19.9094 33.4928 20.1419 32.4894 20.1419C31.7063 20.1419 30.6784 19.8727 29.4059 19.3346L27.9742 18.7476L26.616 18.1973C24.6337 17.3657 22.5046 16.9499 20.2286 16.9499C14.1349 16.9499 9.24043 19.0044 5.54502 23.1136C1.84962 27.2226 0.00195312 32.6402 0.00195312 39.3664C0.00195312 48.8319 2.96312 57.576 8.88554 65.5984C12.997 71.1995 16.7535 74 20.1552 74C21.5991 74 23.0308 73.7187 24.4502 73.1562L26.2489 72.4224L27.6806 71.9088C29.6873 71.1995 31.535 70.8448 33.2236 70.8448C35.0101 70.8448 37.0658 71.2974 39.3908 72.2023L40.5287 72.6425C42.9025 73.5475 44.7748 74 46.1452 74Z"
               fill="#1F473E"
            />
         </g>
         <defs>
            <clippath id="clip0_2355_46612">
               <rect width="63.8768" height="74" fill="white" />
            </clippath>
         </defs>
      </svg>
   )
}
